import type { NewOfflineOperationInput, OfflineOperation } from "./types";

export interface OperationClock {
  now(): Date;
}

export interface OperationIdSource {
  next(): string;
}

const systemClock: OperationClock = {
  now: () => new Date(),
};

const cryptoIdSource: OperationIdSource = {
  next: () => crypto.randomUUID(),
};

export function createOfflineOperation<TPayload extends Readonly<Record<string, unknown>>>(
  input: NewOfflineOperationInput<TPayload>,
  options?: {
    clock?: OperationClock;
    idSource?: OperationIdSource;
  },
): OfflineOperation<TPayload> {
  const clock = options?.clock ?? systemClock;
  const idSource = options?.idSource ?? cryptoIdSource;
  const nowIso = clock.now().toISOString();

  if (!input.operationType.trim()) {
    throw new Error("SYNC_OPERATION_TYPE_REQUIRED");
  }

  if (!Number.isInteger(input.schemaVersion) || input.schemaVersion < 1) {
    throw new Error("SYNC_SCHEMA_VERSION_INVALID");
  }

  return {
    ...input,
    operationId: idSource.next(),
    createdAt: nowIso,
    status: "pending",
    retryCount: 0,
  };
}
